import "./InstructionalVideos.scss"
import { TabPanel } from "devextreme-react"
import { InstructionalVideosList } from "../component/InstructionalVideoList"
import { t } from "i18next"
import { useState } from "react"
import { WatchState } from "../model/InstructionalVideoDtos"
import InstructionalVideosGrid from "../component/InstructionalVideoGrid"
import { LocalStorageKey, localStorageService } from "../../../core/localstorage/service"
import { useTabNavigation } from "../../../core/hook/useTabNaviagation"
import { ActionBar, AppearWrapper, Collapsible, Left, Pill, Right } from "../../../core/components"
import { useMediaQuery } from "react-responsive"
import { useSidebar } from "../../../core/common/sidebar/context/SidebarContext"
import { sideBySideBarDistance } from "devexpress-reporting/scopes/reporting-chart-internal"

function getInitialSelectedWatchStates(): Set<WatchState> {
    const savedSelectedWatchStatesFilter = localStorageService.get<WatchState[]>(LocalStorageKey.INSTRUCTIONAL_VIDEO_GRID_FILTERS)
    if (savedSelectedWatchStatesFilter !== null && savedSelectedWatchStatesFilter?.length > 0) {
        return new Set<WatchState>(savedSelectedWatchStatesFilter)
    }
    return new Set<WatchState>([WatchState.Not, WatchState.Partially])
}

export const InstructionalVideos: React.FC = () => {
    const [selectedWatchStates, setSelectedWatchStates] = useState<Set<WatchState>>(getInitialSelectedWatchStates())
    const sidebar = useSidebar()
    const isSmall = useMediaQuery({query: sidebar.isSidebarExpanded ? "(max-width: 900px)" : "(max-width: 600px)"})

    const tabs = [
        { id: 0, view: "grid", title: t("Grid"), component: <InstructionalVideosGrid selectedWatchStates={selectedWatchStates} /> },
        { id: 1, view: "list", title: t("List"), component: <InstructionalVideosList /> }
    ]

    const tabNavigation = useTabNavigation(tabs, "grid")

    const toggleWatchState = (selected: boolean, value: WatchState) => {
        let newSelectedWatchStates
        if (selected) {
            const set = new Set(selectedWatchStates)
            if (set.has(value)) {
                newSelectedWatchStates = set
            } else {
                set.add(value)
                newSelectedWatchStates = set
            }
        } else {
            const set = new Set(selectedWatchStates)
            set.delete(value)
            newSelectedWatchStates = set
        }

        setSelectedWatchStates(newSelectedWatchStates)
        localStorageService.set(LocalStorageKey.INSTRUCTIONAL_VIDEO_GRID_FILTERS, newSelectedWatchStates)
    }

    return (
        <>
            <ActionBar>
                <Left>
                    <Collapsible collapsed={isSmall}>
                        <AppearWrapper show={tabNavigation.selectedTab === 0}>
                            <div style={{ display: 'flex', gap: "0.5rem", flexDirection: "inherit" }}>
                                <Pill
                                    label={t("NotWatched")}
                                    selected={selectedWatchStates.has(WatchState.Not)}
                                    value={WatchState.Not}
                                    onChange={toggleWatchState} />
                                <Pill
                                    label={t("PartiallyWatched")}
                                    selected={selectedWatchStates.has(WatchState.Partially)}
                                    value={WatchState.Partially}
                                    onChange={toggleWatchState} />
                                <Pill
                                    label={t("FullyWatched")}
                                    selected={selectedWatchStates.has(WatchState.Fully)}
                                    value={WatchState.Fully}
                                    onChange={toggleWatchState} />
                            </div>
                        </AppearWrapper>
                    </Collapsible>
                </Left>
                <Right>
                    <TabPanel
                        className="border-radius-small instructional-videos-tabs"
                        height={"100%"}
                        selectedIndex={tabNavigation.selectedTab}
                        dataSource={tabs}
                        deferRendering
                        onSelectionChanged={tabNavigation.handleTabChange} />
                </Right>
            </ActionBar>
            {tabs[tabNavigation.selectedTab].component}
        </>
    )
}
